<template>
	<div class="bg">
		<div class="root-container">
			<div class="left-box">
			<!-- 	<div class="provider">
					<span class="text1">共建单位</span>
					<span class="text1">重庆大学</span>
					<span class="text1">重庆工程职业技术学院</span>
				</div> -->
				<div class="copyright">
					<span class="text2">版权所有: 北京思越职数教育咨询有限公司</span>
					<span class="text2">地址: 北京市石景山区八大处路49号院4号楼3层3801B</span>
					<span class="text2">京ICP备2025137777号-1 </span>
				</div>
			</div>
			<div class="right-box">
				<img class="pic" src="../assets/icons/qq.png" @click="clickContact('qq')" />
				<img class="pic" src="../assets/icons/wechat.png" @click="clickContact('wx')" />
			</div>
		</div>

		<el-dialog title="联系客服" :visible.sync="showContact" width="45%" align="center">
			<div class="contact-ctr">

				<img class="contact-image" :src="contactUrl" />

				<div class="footer-tips">请扫码添加客服</div>

				<div class="contact-btn-ctr">
					<el-button type="primary" @click="clickClose()" size="medium">关 闭</el-button>
				</div>

			</div>

		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: "Rooter",
		data() {
			return {
				showContact: false,
				wxUrl: 'https://syzsoss.oss-cn-chengdu.aliyuncs.com/202510/16234435-85480558676586283.jpg',
				qqUrl: 'https://syzsoss.oss-cn-chengdu.aliyuncs.com/202510/16234435-85480558676586283.jpg',
				contactUrl: ''
			}
		},
		created() {

		},
		methods: {
			clickContact(type) {
				console.log('type', type)
				if (type == 'qq') {
					this.contactUrl = this.qqUrl;
				} else {
					this.contactUrl = this.wxUrl;
				}
				this.showContact = true;
			},

			clickClose() {
				this.showContact = false;
			}
		}
	}
</script>

<style rel="stylesheet/scss" lang="scss">
	@use "rooter.scss";
</style>